import axios from 'axios';

// Constants
import { ARNEO_ECOCONCEPTION_CROWD_TOKEN, API_CROWD_TOKEN } from '../constants';

/**
 * isInternal
 */
export const isInternal = () => {
  const hostname = window.location.hostname;

  if (
    // Production
    hostname.includes('.arneogroup.com') ||
    // LD
    hostname.includes('.livedemo.fr') ||
    // IC
    hostname.includes('.adfab.fr') ||
    // Local
    hostname.includes('localhost')
  ) {
    return true;
  }

  return false;
};

/**
 * tokenIsValid
 */
export const tokenIsValid = async () => {
  const token = localStorage.getItem(ARNEO_ECOCONCEPTION_CROWD_TOKEN);

  /**
   * Make API call to check User token
   */
  if (token) {
    try {
      const request = await axios.get(getApiBaseUrl() + API_CROWD_TOKEN, {
        params: {
          token,
        },
      });

      if (request && request.status === 200) {
        return true;
      }
    } catch (error) {
      console.error(error && error.message);
    }
  }

  return false;
};

/**
 * Get api base url
 */
export const getApiBaseUrl = () => {
  let baseUrl = window.location.origin;
  if (window.location.hostname === 'localhost') {
    baseUrl = 'http://localhost:3000';
  }

  return baseUrl;
};
